import React, { useCallback, useState } from 'react';
import styles from 'src/styles/layout.module.css';
import { Button, Space, Typography } from 'antd';
import { CloseOutlined, EditOutlined } from '@ant-design/icons';

const ContentCardCollectionsTab: React.FC = () => {
  const [createMode, setCreateMode] = useState<boolean>(false);
  const handleCreateButtonClick = useCallback(() => {
    setCreateMode(m => !m);
  }, []);
  return (
    <Space direction={'vertical'} style={{ width: '100%' }}>
      <div className={styles.header}>
        <Typography.Title level={4}>Коллекции</Typography.Title>
        <Button onClick={handleCreateButtonClick}>{createMode ? <CloseOutlined /> : <EditOutlined />}</Button>
      </div>
      <div className={styles.content} />
    </Space>
  );
};
export default ContentCardCollectionsTab;
